import React from "react";

import { StyledLayoutBadge, LayoutBadgeProps } from "src/shared/ui/badge/styles";

const LayoutBadge: React.FC<LayoutBadgeProps> = ({ layoutBadgeType }) => {
  return <StyledLayoutBadge layoutBadgeType={layoutBadgeType} label={layoutBadgeType} />;
};

export default LayoutBadge;
